// $(document).ready(function () {
var payment = {
  init: function () {
    payment.elements = {};
    payment.bindEvents();
  },
  bindEvents: function () {
    payment.elements.$addressSelect.on("change", function (e) {
      if ($(this).val() == "new") payment.elements.$addDiv.show();
      else payment.elements.$addDiv.hide();
    });
  },
};

var checkout = {
  init: function () {
    checkout.vars = {
      // global
      $window: $(window),
      $body: $("body"),

      // edit cart
      $emptyCartAlert: $(".cart-empty-alert"),
      $removeCartItemLink: $(".remove-cart-item"),
      $cartSubtotalDiv: $("#cart-subtotal"),

      // auth
      $authDivs: $(".auth-div"),
      $authLinks: $(".auth-toggle"),
      $loginDiv: $("#login-div"),
      $signupDiv: $("#signup-div"),
      $forgotDiv: $("#forgot-div"),
      $userAlert: $("#user-alert"),

      // payment select
      $addCardBtn: $("#add-card-btn"),
      $addCardForm: $("#add-card-form"),
      $addCardCancelBtn: $("#add-card-cancel-btn"),

      // payment
      $addressSelect: $("#billing-address-select"),
      $addressNew: $("#new-billing-address"),
      $addressNewNevermind: $("#new-billing-address-nevermind"),

      // checkout
      $placeOrderBtn: $(".btn-place-order"),
    };
    checkout.bindEvents();
  },

  bindEvents: function () {
    // disable button on click
    checkout.vars.$placeOrderBtn.on("click", function (e) {
      checkout.vars.$placeOrderBtn.prop("value", "Processing...");
      checkout.vars.$placeOrderBtn.attr("disabled", true);
      var form = checkout.vars.$placeOrderBtn.closest("form");

      if ($("#special_instructions:visible").length) {
        form.append(
          $("<input>")
            .attr("type", "hidden")
            .attr("name", "special_instructions")
            .val($("#special_instructions").val())
        );
      }

      form.submit();
    }),
      checkout.vars.$removeCartItemLink.on("click", function (e) {
        // save for later
        var url = $(this).attr("href");
        var $row = $(this).closest("tr");

        // disable the link for now
        $(this).attr("href", "javascript:void(0);");

        // ajax call
        request = $.ajax({
          url: url,
          beforeSend: function (xhr) {
            xhr.setRequestHeader(
              "X-CSRF-Token",
              $('meta[name="csrf-token"]').attr("content")
            );
          },
          type: "delete",
        });

        // success = remove row, reload all instances of subtotals
        request.done(function (data, textStatus, jqXHR) {
          $row.fadeOut(300, function () {
            $row.remove();
          });
          $(".cart-grandtotal").text(
            "$" + parseFloat(data.grandtotal).toFixed(2)
          );
          $(".cart-size").each(function () {
            $(this).text(parseInt($(this).text() - 1));
          });
          nav.reload();
        });

        // fail = enable link, alert
        request.fail(function (jqXHR, textStatus, errorThrown) {
          $(this).attr("href", url);
          alert("There was a problem removing the cart item");
        });

        // always = show empty message if necessary
        request.always(function () {
          if ($("table.cart-items tbody tr").length == 1) {
            $("table.cart-items").hide();
            checkout.vars.$emptyCartAlert.show();
            checkout.vars.$cartSubtotalDiv.hide();
          }
        });

        e.preventDefault();
      });

    checkout.vars.$authLinks.on("click", function (e) {
      e.preventDefault();
      checkout.vars.$userAlert.hide();
      checkout.vars.$authDivs.hide();
      var $div = checkout.vars.$signupDiv;
      checkout.vars.$authDivs.find(":input").attr("disabled", true);
      if ($(this).hasClass("auth-login")) {
        $div = checkout.vars.$loginDiv;
      } else if ($(this).hasClass("auth-forgot")) {
        $div = checkout.vars.$forgotDiv;
      }
      $div.show();
      $div.find(":input").attr("disabled", false);
    });

    // payment select
    checkout.vars.$addCardBtn.on("click", function (e) {
      e.preventDefault();
      checkout.vars.$addCardBtn.hide();
      checkout.vars.$addCardForm.slideDown("fast");
    });
    checkout.vars.$addCardCancelBtn.on("click", function (e) {
      e.preventDefault();
      checkout.vars.$addCardForm.slideUp("fast", function () {
        checkout.vars.$addCardBtn.show();
      });
    });

    checkout.vars.$addressSelect.on("change", function (e) {
      if ($(this).val() == "new") {
        checkout.vars.$addressNew.show();
      } else {
        checkout.vars.$addressNew.hide();
      }
    });
  },
};
//$(document).ready(checkout.init);
$(document).on("turbolinks:load", checkout.init);
// $(".btn-place-order.bottom").affix({
//   offset: {
//     top: 120,
//   },
// });
// });
